import { useContext, useState, Fragment } from 'react';
import { MainContext } from '../../contexts/main';
import { BlockInfoLicense } from './BlockInfoLicense';
import config from '../../resources/config.json';
import { getText } from '@educaplay/app-core/language';
import { timestampToFullDate, timestampToLongDate } from '@educaplay/app-core/time';
import { SVG_back, SVG_corg, SVG_licenses } from '../elements/SVG';
import OutsideAlerter from '../elements/OutsideAlerter';
import { ModalCancel } from '../modals/ModalCancel';
import { InputUpDown } from '../inputs/InputUpDown';
import { numberFormat } from '../../helpers/functions';
import { renewalText } from '../../helpers/renewal';
import { getPlanMainAction } from '../../helpers/billing';

export const BlockSummaryOptions = ({ handleCancel, mode }) => {

    const { mainReducer, environment } = useContext(MainContext);

    const [stateExpanded, setStateExpanded] = useState(false);

    const [openCancelDialog, setOpenCancelDialog] = useState(false);

    const [stateSettingsOpen, setStateSettingsOpen] = useState(false);

    const hasRenewal = mainReducer.state.currentLicense.id != 0;

    const handleEdit = () => {
        setStateSettingsOpen(false);
        setStateExpanded(!stateExpanded);
    }

    const handleSubscribe = () => {
        mainReducer.dispatch({
            type: 'changeIdLicense',
            payload: mainReducer.state.inProgressLicense.id
        });
        mainReducer.dispatch({
            type: 'changePeriodicity',
            payload: mainReducer.state.inProgressLicense.periodicity
        });
        handleChangeLicenses(mainReducer.state.inProgressLicense.licenses);
        handleEdit();
    }

    const planActions = {
        upgrade: { text: 'mejorar_plan', handler: handleEdit },
        change: { text: 'change_plan', handler: handleEdit },
        buy: { text: 'buy_plan', handler: handleSubscribe },
        undoCancel: { text: 'undo_cancel_plan', handler: handleSubscribe }
    };

    const mainAction = planActions[getPlanMainAction(mainReducer.state)];

    const handleOpenCancel = () => {
        setStateSettingsOpen(false);
        setOpenCancelDialog(true);
    }

    const handleOnChangePeriodicity = ({ target }) => {
        const action = {
            type: 'changePeriodicity',
            payload: target.value
        };
        mainReducer.dispatch(action);
    }

    const handleOnChangeId = ({ target }) => {
        const action = {
            type: 'changeIdLicense',
            payload: target.value
        };
        mainReducer.dispatch(action);
    }

    const handleChangeLicenses = (newValue) => {
        if (newValue > 1 && mainReducer.state.selectedLicense.periodicity === "monthly") {
            const action = {
                type: 'changePeriodicity',
                payload: 'yearly'
            };
            mainReducer.dispatch(action);
        }
        const action = {
            type: 'changeLicenses',
            payload: newValue
        };
        mainReducer.dispatch(action);
    }

    return <>
        <ModalCancel openCancelDialog={openCancelDialog} setOpenCancelDialog={setOpenCancelDialog} handleCancel={handleCancel} />
        <section className={`e__plns__hdg${(stateExpanded) ? ' act' : ''}`}>
            <div className="e__plns__hdg__wpr">
                <div className="e__plns__hdg__wrp">
                    <div className='e__plns__hdg__wrp__lst'>
                        {((mainReducer.state.subLicense !== false) && (mainReducer.state.subLicense <= mainReducer.state.currentLicense.id)) &&
                            <div className='e__plns__hdg__wrp__lst__plan'>
                                <div className="e__plns__lst__hd__hdg">{getText('plan_asignado')}:</div>
                                <BlockInfoLicense license={{ id: mainReducer.state.subLicense }} />
                                <span className="e__plns__lst__hd__ico">
                                    <SVG_back />
                                </span>
                            </div>
                        }
                        {((mainReducer.state.inProgressLicense.id == mainReducer.state.currentLicense.id) && (mainReducer.state.inProgressLicense.periodicity == mainReducer.state.currentLicense.periodicity) && (mainReducer.state.inProgressLicense.licenses == mainReducer.state.currentLicense.licenses)) ?
                            <div className='e__plns__hdg__wrp__lst__plan'>
                                <div className="e__plns__lst__hd__hdg">
                                    {(mainReducer.state.pendingRenewal !== false) ?
                                        renewalText('renewal_pending_header', { fecha: timestampToFullDate(mainReducer.state.pendingRenewal.dueDate) })
                                    :
                                        <>{getText('proxima_renovacion')} {timestampToLongDate(mainReducer.state.inProgressLicense.expiration)}:</>
                                    }
                                </div>
                                <BlockInfoLicense license={mainReducer.state.currentLicense} />
                                <span className="e__plns__lst__hd__ico">
                                    <SVG_back />
                                </span>
                            </div>
                            :
                            <>
                                <div className='e__plns__hdg__wrp__lst__plan'>
                                    <div className="e__plns__lst__hd__hdg">{getText('plan_contratado')}:</div>
                                    <BlockInfoLicense license={mainReducer.state.inProgressLicense} />
                                    <span className="e__plns__lst__hd__ico">
                                        <SVG_back />
                                    </span>
                                </div>
                                <div className='e__plns__hdg__wrp__lst__plan'>
                                    <div className="e__plns__lst__hd__hdg">{getText('a_partir_de')} {timestampToLongDate(mainReducer.state.inProgressLicense.expiration)}:</div>
                                    <BlockInfoLicense license={mainReducer.state.currentLicense} />
                                    <span className="e__plns__lst__hd__ico">
                                        <SVG_back />
                                    </span>
                                </div>
                            </>
                        }
                        {((mainReducer.state.subLicense !== false) && (mainReducer.state.subLicense > mainReducer.state.currentLicense.id)) &&
                            <div className='e__plns__hdg__wrp__lst__plan'>
                                <div className="e__plns__lst__hd__hdg">{getText('plan_asignado')}:</div>
                                <BlockInfoLicense license={{ id: mainReducer.state.subLicense }} />
                                <span className="e__plns__lst__hd__ico">
                                    <SVG_back />
                                </span>
                            </div>
                        }
                    </div>
                    {(!stateExpanded) &&
                        <button className="e-btn e-btn--link e__plns__actn" type="button" onClick={mainAction.handler}>
                            <span className="e-btn__txt e__lnk">{getText(mainAction.text)}</span>
                        </button>
                    }
                </div>
            </div>
        </section>
        {(!stateExpanded || (mode == 'edit' && hasRenewal)) &&
            <div className={`e-dropdown e__plns__stngs${(stateSettingsOpen) ? ' dropdown--is-open' : ''}`}>
                <OutsideAlerter action={() => setStateSettingsOpen(false)}>
                    <button className="e-btn e-btn--square" type="button" aria-label={getText('opciones_de_plan')} title={getText('opciones_de_plan')} aria-expanded={stateSettingsOpen} onClick={() => setStateSettingsOpen(!stateSettingsOpen)}>
                        <span className="e-icon"><SVG_corg /></span>
                    </button>
                    <div className="e-dropdown__content">
                        {(!stateExpanded) &&
                            <button className="e-dropdown__item" type="button" onClick={mainAction.handler}>
                                <span className="e-dropdown__txt">{getText(mainAction.text)}</span>
                            </button>
                        }
                        {(mode == 'edit') && hasRenewal &&
                            <button className="e-dropdown__item e__plns__stngs__cncl" type="button" onClick={handleOpenCancel}>
                                <span className="e-dropdown__txt">{getText('cancelar_suscripcion')}</span>
                            </button>
                        }
                    </div>
                </OutsideAlerter>
            </div>
        }
        {(stateExpanded) &&
            <fieldset className="e__plns__opt__box act">
                <legend>
                    {getText('opciones_de_plan')}
                    <span className="e__btn__info">
                        <button className="e__btn" aria-label={getText('mas_informacion')} title={getText('mas_informacion')}>i</button>
                        <span className="e__btn__info__wp">{getText('opciones_de_plan_txt')}</span>
                    </span>
                </legend>
                <div className="e__plns__opt__box__wpr">
                    <div className="e__plns__opt__plan">
                        <div className="e__slct e__slct--hd">
                            <div className="e__slct__hd">
                                <label htmlFor="plan_id">{getText('plan_educaplay')}:</label>
                            </div>
                            <select id={`plan_periodicity`} onChange={handleOnChangeId} value={mainReducer.state.selectedLicense.id}>
                                {Object.keys(config.plans).map(plan =>
                                    <Fragment key={plan}>
                                        {(plan > 0) &&
                                            <option value={plan}>
                                                {getText('plan_name_' + plan)}
                                            </option>
                                        }
                                    </Fragment>
                                )}
                            </select>
                        </div>
                    </div>
                    <div className="e__plns__opt__lcns">
                        <div className="e__plns__opt__hd">
                            <div>{getText('field_licenses_title')}:</div>
                        </div>
                        <div className="flex  flex-column align-center">
                            <InputUpDown value={mainReducer.state.selectedLicense.licenses} handleSave={handleChangeLicenses} min={1} icon={<SVG_licenses />} />
                            {(mainReducer.state.discountApplied != 0) &&
                                <span className="e__plns__dscount">
                                    <span className="e__plns__dscount__nmbr">{numberFormat(mainReducer.state.discountApplied, 2, environment) + '%'}</span>
                                    {getText('porcentaje_ahorro_por_licencia')}
                                </span>
                            }
                        </div>
                    </div>
                    <div className="e__plns__opt__perid">
                        <div className="e__slct e__slct--hd">
                            <div className="e__slct__hd">
                                <label htmlFor="plan_periodicity">{getText('periodicidad')}:</label>
                            </div>
                            <select id={`plan_periodicity`} onChange={handleOnChangePeriodicity} value={mainReducer.state.selectedLicense.periodicity} disabled={mainReducer.state.selectedLicense.licenses > 1}>
                                {Object.keys(config.periodicities).map(periodicity =>
                                    <option key={periodicity} value={periodicity}>
                                        {getText('periodicity_' + periodicity)}
                                    </option>
                                )}
                            </select>
                            {(mainReducer.state.selectedLicense.periodicity == config.defaultPeriodicity) &&
                                <span className="e__plns__dscount">
                                    <span className="e__plns__dscount__nmbr">{mainReducer.state.discountForPeriodicity[mainReducer.state.selectedLicense.id][mainReducer.state.selectedLicense.periodicity] + '%'}</span>
                                    {getText('porcentaje_ahorro_por_periodicidad')}
                                </span>
                            }
                        </div>
                    </div>
                </div>
            </fieldset>
        }
    </>;
}
